let closeMovesFocusToPage = false;

/** Route change should land on the page heading, not the menu button. */
export function focusPageAfterSidebarClose() {
  closeMovesFocusToPage = true;
}

export function takeSidebarCloseFocusTarget() {
  const toPage = closeMovesFocusToPage;
  closeMovesFocusToPage = false;
  return toPage ? 'page-heading' : 'dashboard-menu-button';
}
